class HemsireIsAramaKriterleri {
    baslangicTarih: string = null;
    bitisTarih: string = null;
    baslangicSaat: string = null;
    bitisSaat: string = null;
    aktifServis: boolean = false;
    uygulamaBekleyenler: boolean = false;
    uygulamaYapilanlar: boolean = false;
    tumHastalar: boolean = false;
    servisId: number = null;
}

export default HemsireIsAramaKriterleri;
